const prefix = 'COMPLAINTS_';

export const ClientComplaintsActionTypes = {
  GET_CLIENT_COMPLAINTS_LIST: `${prefix}GET_CLIENT_COMPLAINTS_LIST`,
  SET_CLIENT_COMPLAINTS_LIST: `${prefix}SET_CLIENT_COMPLAINTS_LIST`,
  GET_CLIENT_EXTENDED_COMPLAINTS_LIST: `${prefix}GET_CLIENT_EXTENDED_COMPLAINTS_LIST`,
  SET_CLIENT_COMPLAINTS_INITIAL: `${prefix}SET_CLIENT_COMPLAINTS_INITIAL`,
  TOGGLE_COMPLAINTS_MODAL: `${prefix}TOGGLE_COMPLAINTS_MODAL`,
  SET_INITIAL_REQUEST_COMPLAINTS: `${prefix}SET_INITIAL_REQUEST_COMPLAINTS`,
  SET_COMPLAINTS_REQUEST: `${prefix}SET_COMPLAINTS_REQUEST`,
  GET_COMPLAINTS_TYPES: `${prefix}GET_COMPLAINTS_TYPES`,
  SET_COMPLAINTS_TYPES: `${prefix}SET_COMPLAINTS_TYPES`,
  STORE_COMPLAINTS_REQUEST: `${prefix}STORE_COMPLAINTS_REQUEST`,
  SET_STORE_LOADING: `${prefix}SET_LOADING`,
  SET_DATA_VALIDATION: `${prefix}SET_DATA_VALIDATION`,
  SET_COMPLAINTS_FILE: `${prefix}SET_COMPLAINTS_FILE`,
  SET_COMPLAINT_SUBMITTED: `${prefix}SET_COMPLAINT_SUBMITTED`,
};

const getClientComplaintsList = () => ({ type: ClientComplaintsActionTypes.GET_CLIENT_COMPLAINTS_LIST });
const getExtendedClientComplaintsList = () => ({ type: ClientComplaintsActionTypes.GET_CLIENT_EXTENDED_COMPLAINTS_LIST });
const setClientComplaintsInitial = () => ({ type: ClientComplaintsActionTypes.SET_CLIENT_COMPLAINTS_INITIAL });
const toggleComplaintsModal = () => ({ type: ClientComplaintsActionTypes.TOGGLE_COMPLAINTS_MODAL });
const setInitialRequestComplaints = (data: {orderId: string}) => ({ type: ClientComplaintsActionTypes.SET_INITIAL_REQUEST_COMPLAINTS, data: data });
const setComplaintsRequest = (data: { key: 'title' | 'description' | 'type_id', value: string }) => ({ type: ClientComplaintsActionTypes.SET_COMPLAINTS_REQUEST, data: data });
const getComplaintsTypes = () => ({ type: ClientComplaintsActionTypes.GET_COMPLAINTS_TYPES });
const storeComplaintsRequest = () => ({ type: ClientComplaintsActionTypes.STORE_COMPLAINTS_REQUEST });
const setDataValidation = () => ({ type: ClientComplaintsActionTypes.SET_DATA_VALIDATION });
const setComplaintsFile = (data: {file: object}) => ({ type: ClientComplaintsActionTypes.SET_COMPLAINTS_FILE, data: data });
const setComplaintSubmitted = (data: {complaintSubmitted: boolean}) => ({ type: ClientComplaintsActionTypes.SET_COMPLAINT_SUBMITTED, data: data });

export const ClientComplaintsActions = {
  getClientComplaintsList: getClientComplaintsList,
  getExtendedClientComplaintsList: getExtendedClientComplaintsList,
  setClientComplaintsInitial: setClientComplaintsInitial,
  toggleComplaintsModal: toggleComplaintsModal,
  setInitialRequestComplaints: setInitialRequestComplaints,
  setComplaintsRequest: setComplaintsRequest,
  getComplaintsTypes: getComplaintsTypes,
  storeComplaintsRequest: storeComplaintsRequest,
  setDataValidation: setDataValidation,
  setComplaintsFile: setComplaintsFile,
  setComplaintSubmitted: setComplaintSubmitted,
};

